import i18next from "i18next"
import { CreateWhatsappTemplateSchema } from "schema"

export const WhatsappTemplateFormSchema = CreateWhatsappTemplateSchema.superRefine(
  ({ template }, ctx) => {
    template.buttons?.forEach((button, index) => {
      if (button.urlType === "STATIC" || button.variableDescription?.trim()) return

      ctx.addIssue({
        code: "custom",
        path: ["template", "buttons", index, "variableDescription"],
        message: i18next.t(
          "campaigns.templates.whatsapp.detail.config.blocks.templateVariableDescriptionRequired",
        ),
      })
    })

    template.whatsappTemplateVariables?.forEach((variable, index) => {
      if (!variable.description?.trim()) {
        ctx.addIssue({
          code: "custom",
          path: ["template", "whatsappTemplateVariables", index, "description"],
          message: i18next.t(
            "campaigns.templates.whatsapp.detail.config.blocks.templateVariableDescriptionRequired",
          ),
        })
      }
    })
  },
)
